import { createFileRoute } from '@tanstack/react-router'
import VideoStatsTableContainer from '../components/VideoStatsTableContainer'

export const Route = createFileRoute('/video-stats')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <VideoStatsTableContainer />
    </div>
  )
}
